const compareVersion = (v1 = "0", v2 = "0") => {
  const spliter = ".";
  const version1 = v1.split(spliter);
  const version2 = v2.split(spliter);
  const len = Math.max(version1.length, version2.length);
  const vs1 = [...version1, ...Array(len - version1.length).fill(0)];
  const vs2 = [...version2, ...Array(len - version2.length).fill(0)];
  for (let i = 0; i < len; ) {
    const part1 = parseInt(vs1[i], 10);
    const part2 = parseInt(vs2[i], 10);
    if (part1 > part2) {
      return true;
    }
    if (part1 < part2) {
      return false;
    }
    i += 1;
  }
  return true;
};
export {
  compareVersion
};
